type Props = { ok: boolean; label: string; detail?: string | null }

/** Square status dot + label — never color alone (the label says ok/down). */
export function StatusDot({ ok, label, detail }: Props) {
  return (
    <span className="inline-flex items-center gap-1.5" title={detail ?? undefined}>
      <span
        aria-hidden
        className="inline-block size-2"
        style={{ background: ok ? "var(--status-ok)" : "var(--viz-failed)" }}
      />
      <span className="font-mono text-xs text-muted-foreground">
        {label} <span className="text-foreground">{ok ? "ok" : "down"}</span>
      </span>
    </span>
  )
}
